/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trialbannertitle2Inputs */

const en_trialbannertitle2 = /** @type {(inputs: Trialbannertitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're on a free trial`)
};

const de_trialbannertitle2 = /** @type {(inputs: Trialbannertitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du nutzt ein kostenloses Testabo`)
};

/**
* | output |
* | --- |
* | "You're on a free trial" |
*
* @param {Trialbannertitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const trialbannertitle2 = /** @type {((inputs?: Trialbannertitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trialbannertitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trialbannertitle2(inputs)
	return de_trialbannertitle2(inputs)
});
export { trialbannertitle2 as "trialBannerTitle" }